/**
 * @desc 通过id获取主体详情
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.OrderCompanyDetailDto>;
export function request(id: number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/orderCompany/getDetailById/${id}`, {
      method: "POST",

      ...options,
    }),
  );
}
